import { render, staticRenderFns } from "./NewsRadarScoring.vue?vue&type=template&id=3dee57c6&"
import script from "./NewsRadarScoring.vue?vue&type=script&lang=js&"
export * from "./NewsRadarScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
